var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramTax40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tax40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Picto",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "64x64x",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Pillar-Big",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 9.375,
    y: 14.0625,
    width: 11.25,
    height: 8.4375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Pillar",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 13.125,
    y: 13.125,
    width: 3.75,
    height: 10.78125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Step",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 6.5625,
    y: 22.5,
    width: 16.875,
    height: 3.28125
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Roof",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    points: "15 7.03125 23.4375 14.53125 6.5625 14.53125"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Flag",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    x: 15,
    y: 3.28125,
    width: 5.625,
    height: 3.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramTax40);
export default __webpack_public_path__ + "static/media/pictogramTax40.584ce5f92ebf08ea5411e6e4ad62ef30.svg";
export { ForwardRef as ReactComponent };